<template>
  <section>
    {{addEventPixeleFacebook()}}
    <div class="ew-navbar ew-white p-3 ew-mb">
      <router-link to="/shipments" class="btn btn-lg btn-white text-dark">
        <img src="@/assets/images/back-arrow.png" alt=""> Cancelar
      </router-link>
    </div>
  <section>
    <div class="ew-smaller-container ew-mb">
      <div class="ew-empty" v-if="!shipments || shipments.length === 0">
        <ph-icon name="package" />
        <p class="ew-empty__title">No hay envíos para pagar</p>
        <p class="ew-empty__text">Vuelve a Mis Envíos y selecciona los envíos que quieres pagar.</p>
        <router-link class="ew-btn-primary" to="/shipments">Ir a Mis Envíos</router-link>
      </div>

      <template v-else>
        <div class="ew-card ew-summary-card">
          <p class="ew-card-title">Resumen de compra</p>
          <div class="ew-summary-detail">
            <div class="ew-summary-row" v-for="(shipment, i) in shipments" :key="i">
              <span>{{ shipment.destination_direction.full_name }}, {{ shipment.destination_direction.address }}<br>C.P. {{ shipment.destination_direction.postal_code }}<br>{{ shipment.selected_service.carrier_service_name }}</span>
              <span>{{ shipment.selected_service.currency }} {{ formatMXN(shipment.selected_service.total_amount) }}</span>
            </div>
            <div class="ew-summary-total"><span>Total</span><span>MXN {{ formatMXN(totalPayment(shipments)) }}</span></div>
          </div>
        </div>

        <div class="ew-card">
          <p class="ew-card-title">Método de pago</p>
          <form @submit.prevent>
            <div class="ew-pay-options">
              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal' }">
                <input type="radio" name="paymentMethod" v-on:click="paymentsPaypal">
                <img class="ew-pay-option__logo" src="@/assets/images/paypal.png" alt="">
                <span class="ew-pay-option__label">PayPal</span>
              </label>

              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal-plus' }">
                <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'paypal-plus'">
                <img class="ew-pay-option__logo ew-pay-option__logo--card" src="@/assets/images/card-paypal.png" alt="">
                <span class="ew-pay-option__label">Pago con tarjeta</span>
              </label>

              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'oxxo' }">
                <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'oxxo'">
                <img class="ew-pay-option__logo" src="@/assets/images/oxxopay_brand.png" alt="">
                <span class="ew-pay-option__label">OXXO</span>
              </label>

              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'monedero', 'is-disabled': monederoDisabled }">
                <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'monedero'" :disabled="monederoDisabled">
                <ph-icon name="wallet" />
                <span class="ew-pay-option__label">
                  Monedero electrónico
                  <small class="ew-pay-option__hint" v-if="monederoLoading">Consultando saldo…</small>
                  <small class="ew-pay-option__hint" v-else-if="monederoDisabled">Saldo insuficiente</small>
                </span>
                <span class="ew-pay-option__balance">{{ monederoLoading ? '' : formatMXN(total_monedero) }}</span>
              </label>
            </div>

            <div class="ew-pay-actions">
              <a :href="paypalLink" class="ew-btn-primary" v-if="paypalLink !== '' && paymentMethod === 'paypal'">Pagar</a>

              <button
                type="submit"
                id="miniBrowserInitiateCheckout"
                class="ew-btn-primary"
                @click="initIframePayPalPlus(); return false;"
                v-if="paypalpluslink !== '' && paymentMethod === 'paypal-plus'"
              >Pagar con tarjeta</button>

              <button type="button" class="ew-btn-primary" v-if="paymentMethod === 'oxxo'" v-on:click="paymentOXXO">Pagar</button>

              <button
                type="button"
                class="ew-btn-primary"
                v-if="paymentMethod === 'monedero'"
                v-on:click="paymentMonedero"
                :disabled="monederoDisabled"
              >Pagar con monedero</button>
            </div>
            <div class="ew-field-error" v-if="paymentError">{{ paymentError }}</div>
          </form>
        </div>
      </template>
    </div>
  </section>
    <div id="ppplusDiv"> </div>
  </section>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import commons from '../commons'
import { formatMXN } from '../commons/currency'
import PhIcon from './icons/PhIcon'

 import api from "../commons/api";


export default {
  name: 'PaymentsDetails',
  data () {
    return {
      paypalLink: '',
      paypalplay:null,
      paypalpluslink:"",
      isLoading: true,
      shipments:null,
      paymentMethod: 'paypal',
      isPaymentGuide:false,
      payDisabled:false,
      monederoDisabled: true,
      monederoLoading: true,
      total_monedero: 0,
      paymentError:'',

    }
  },
  created () {
    this.getUser();
    this.shipments = this.paymentShipments
    // Navegar aquí directo (sin pasar por Mis Envíos) deja this.shipments
    // vacío, porque viene del estado de Vuex (paymentShipments), no de una
    // petición al servidor — sin este guard, getTotalAmountPrepaids()
    // tronaba al intentar sumar un arreglo vacío/nulo.
    if (this.shipments && this.shipments.length > 0) {
      this.getTotalAmountPrepaids();
      this.getLinkPaypalPlus();
    }
  },
  methods: {
    formatMXN,
    getTotalAmountPrepaids () {
      axios
      .get(`${commons.apiURL}/api/v1/prepaid/getTotalAmount/${localStorage.getItem('ew-user-id')}`)
      .then(response => {
         this.total_monedero = parseFloat(response.data.total_amount) || 0
         this.monederoDisabled = this.total_monedero < this.totalPayment(this.shipments);
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        this.monederoLoading = false
      })
    },
    addEventPixeleFacebook(){
      fbq('track', 'InitiateCheckout');
    },
    paymentOXXO(){
      if ("oxxo" === this.paymentMethod) {
        this.payDisabled = true;
        this.paymentError = '';
        axios.post(`${commons.apiURL}/api/v1/payments/many/conekta/oxxo/`, {email:this.user.email, shipments:this.shipments}).then(response => {
          if (response.data.message === "ok") {
               this.$router.push({ path: '/payments/result/success', query: { oxxo: 'true',reference:response.data.reference, email:this.user.email }})
            }else{
              this.payDisabled = false;
              this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
            }
        }).catch(() => {
          this.payDisabled = false;
          this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
        })
      }
    },
    paymentMonedero() {
      if ("monedero" === this.paymentMethod && !this.monederoDisabled) {
        this.monederoDisabled = true;
        this.paymentError = '';
        axios
          .post(
            `${commons.apiURL}/api/v1/payments/many/monedero`,
            { email: this.user.email, user: `${localStorage.getItem('ew-user-id')}`,  shipments:this.shipments }
          )
          .then(response => {
            if (response.data.message === "ok") {
              this.monederoDisabled = true;
              this.$router.push({
                path: "/payments/result/success",
                query: {
                  monedero: "true",
                  email: this.user.email
                }
              });
            } else {
              this.monederoDisabled = false;
              this.paymentError = response.data.error || 'No se pudo pagar con monedero. Intenta de nuevo.';
            }
          })
          .catch(() => {
            this.monederoDisabled = false;
            this.paymentError = 'No se pudo pagar con monedero. Intenta de nuevo.';
          });
      }
    },
    getShipment (id) {

    },
    paymentsPaypal() {
      this.paymentMethod = 'paypal'
      if (this.paymentMethod  === 'paypal') {
          axios.post(`${commons.apiURL}/api/v1/payments/many/paypal`, {email:this.user.email, shipments:this.shipments}).then(response => {
          if (response.data.url) {
            this.paypalLink = response.data.url
          }
        })
      }
    },
    getLinkPaypalPlus(){
    axios.post(`${commons.apiURL}/api/v1/paypal/plus/many/link`, {email:this.user.email, shipments:this.shipments}).then(response => {
        let data = response.data.data;
        if (data) {
         this.paypalpluslink = data.link;
         this.payment_id = data.payment_id;
        }
      }).catch((error)=>{
        this.paypalpluslink = ""
      })
    },
    initIframePayPalPlus(){
      this.paypalplay = PAYPAL.apps.PPP({
        approvalUrl: this.paypalpluslink,
        placeholder: "ppplusDiv",
        mode: "live",
        payerEmail:`${this.user.email}`,
        payerFirstName: `${this.user.first_names}`,
        payerLastName: `${this.user.last_names}`,
        payerPhone: `${this.shipments[0].origin_direction.phone}`,
        payerTaxId: "",
        payerTaxIdType: "",
        country: "MX",
        language:"es_MX",
        miniBrowser:true,
        buttonLocation:"inside",
        disallowRememberedCards:true,
        onMiniBrowserClose:function () {
          console.log("close")
        },
        onContinue:(rememberedCards, payer_id, token) => {
          let email = this.user.email;
          api.shipment.executeManyPayment(this.payment_id, payer_id, this.shipments, email).then((response)=>{
            let data = response.data.data;
            if (data.execute) {
                this.$router.push({path: `/payments/result/success?home=true&email=${email}`});
            }else{
                this.$router.push({path: "/payments/result/error"});
            }
          }).catch((error)=>{
              this.$router.push({path: "/payments/result/error"});
          })
        },
        onError: function (err) {
          this.$router.push({path: "/payments/result/error"});
        },
        onLoad:function(){
          console.log("carga realizada con exito")
        }
      });
    },

    totalPayment(shipments){
      let total = 0
      shipments.forEach(element => {
        total = total + parseFloat(element.selected_service.total_amount)
      })
      return total
    },
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user', , "paymentShipments"])
  },
  components: {
    'ph-icon': PhIcon
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/variables";
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 450px; margin: 0 auto; }

.ew-navbar {
  .btn {
    font-size: 1.5rem;
  }
}

.ew-mb{
  margin-bottom: 5rem;
}

.ew-card { @include ew-card; padding: 1.5rem 1.75rem; margin-bottom: 1.25rem; }
.ew-card-title { @include ew-card-title; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-summary-card { @include ew-summary-card; }
.ew-summary-row { @include ew-summary-row; }
.ew-summary-total { @include ew-summary-total; }

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-pay-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}
.ew-pay-option {
  @include ew-pay-option;
  &.is-disabled { opacity: 0.55; cursor: not-allowed; &:hover { background: none; } }
}
.ew-pay-option__hint { display: block; font-size: 0.72rem; font-weight: 600; color: #C8102E; }

.ew-pay-actions {
  display: flex;
  justify-content: flex-end;

  .ew-btn-primary { width: 100%; height: 3rem; text-decoration: none; text-align: center; }
}

.ew-field-error { @include ew-field-error; }
</style>



// WEBPACK FOOTER //
// src/components/PaymentsDetails.vue